export * from '~/sites/oknanebodvere/store/article'

import { actions as baseActions } from '~/sites/oknanebodvere/store/article'
import { getQueryFilter } from '~/queries/plugins'
import articleFragments from '~/queries/fragments/article'
import contentBlocksQuery from '~/app/contentBlocksQuery'
import gql from 'graphql-tag'
import processContentBuilder from '~/app/processContentBuilder'

export const actions = {
  ...baseActions,
  async LOAD_ARTICLE({ dispatch }, { checkPermissions, slug }) {
    try {
      let { siteCode } = this.$themeSettings || {}

      if (siteCode) {
        siteCode = `"${siteCode}"`
      }

      const client = this.app.apolloProvider.defaultClient
      const filter = getQueryFilter({
        checkPermissions,
        options: [['filters.page_meta.slug[0]', `"${slug}"`], ['filters.site_enabled', siteCode]],
      })
      const result = await client.query({
        query: gql`
          ${articleFragments.all}
          {
            article${filter} {
              entities {
                ...articleFragmentsAll
                content_blocks {
                  ${contentBlocksQuery()}
                }
              }
              error {
                statusCode
              }
            }
          }
        `,
      })
      if (result.data.article.error) {
        return { error: result.data.article.error }
      }
      const article = ((result.data.article || {}).entities || [])[0]
      const { content } = article || {}
      if (content) {
        article.content = await processContentBuilder(content, dispatch)
      }
      return article
    } catch (e) {
      console.error(e)
    }
  },
}
